import { render } from "./MenuBottomComponent.vue?vue&type=template&id=0940249f&scoped=true"
const script = {}

import "./MenuBottomComponent.vue?vue&type=style&index=0&id=0940249f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0940249f"]])

export default __exports__